import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ae88603a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ae88603a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae88603a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae88603a')) {
      api.createRecord('ae88603a', component.options)
    } else {
      api.reload('ae88603a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ae88603a&scoped=true", function () {
      api.rerender('ae88603a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/adminEdit/index.vue"
export default component.exports